import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;

let curLang = location.href.substring(location.href.lastIndexOf("/")+1)
if (!curLang || ["cn", "en", "jp", "kr", "hk"].indexOf(curLang) == -1) {
  curLang = "en";
}

const i18n = new VueI18n({
  locale: curLang, 
  messages: {
    'cn': require('@/assets/lang/cn.js'),
    'en': require('@/assets/lang/en.js'),
    'jp': require('@/assets/lang/jp.js'),
    'kr': require('@/assets/lang/kr.js'),
    'hk': require('@/assets/lang/hk.js'),
  }
})

new Vue({
  i18n,  
  axios,
  vuetify,
  render: h => h(App)
}).$mount('#app')
